import { html, ref, when } from '@microsoft/fast-element';
import type { AnalyticsWizard } from './analytics-wizard';

export const AnalyticsWizardTemplate = html<AnalyticsWizard>`
    <div class="wizard-wrapper">
        <div 
            @click="${(x) => x.changeStep(1)}" 
            class="step ${(x) => (x.buyerAnalyticsService.currentStep == 1 ? 'no-click' : '')} ${(
  x
) => (x.currentStep === 1 ? 'selected' : '')}"
        >   
            <span>Metric Preferences</span>
        </div>
        <div 
            @click="${(x) => x.changeStep(2)}" 
            class="step ${(x) => (x.buyerAnalyticsService.currentStep == 1 ? 'no-click' : '')} ${(
  x
) => (x.currentStep === 2 ? 'selected' : '')}"
        >
            <span>Drilldown<span>
        </div>
        <div 
            @click="${(x) => x.changeStep(3)}" 
            class="step ${(x) => (x.buyerAnalyticsService.currentStep == 1 ? 'no-click' : '')} ${(
  x
) => (x.currentStep === 3 ? 'selected' : '')}"
        >
            <span>Comparison</span>
        </div>
        ${when(
            (x) => x.currentStep === 3,
            html<AnalyticsWizard>`
            <zero-button
            slot="end"
            appearance="tab-primary"
            style="margin-left:auto;margin-right: 0;"
            @click=${(x) => x.clearOptions()}>
            Clear Analytics Preferences
            </zero-button>
        `
        )}
    </div>
    
    ${when(
      (x) => x.currentStep === 1,
      html<AnalyticsWizard>`
        <analytics-step-one></analytics-step-one>
      `
    )}

    ${when(
      (x) => x.currentStep === 2,
      html<AnalyticsWizard>`
        <analytics-step-two></analytics-step-two>
      `
    )}

    ${when(
      (x) => x.currentStep === 3,
      html<AnalyticsWizard>`
        <analytics-step-three></analytics-step-three>
      `
    )}
`;
